<template>
    <Head>
        <title v-if="seoTags?.page_title">{{ seoTags.page_title }}</title>
        <title v-else></title>

        <meta v-if="seoTags?.meta_description"
              head-key="description"
              name="description"
              :content="seoTags.meta_description">
        <meta v-else head-key="description" name="description" content="Tyre Seeker is a platform that provides unbiased and informative reviews from real customers of tyres to help you make an informed decision before purchasing.">

        <link v-if="seoTags?.canonical_tag" head-key="canonical" rel="canonical" :href="seoTags.canonical_tag">

        <slot></slot>
    </Head>
</template>

<script setup>
import {Head, usePage} from "@inertiajs/inertia-vue3";
import {computed} from "vue";

const props = defineProps({
    noAppName: Boolean
});

const seoTags = computed(() => {
    return usePage().props.value.seoTags;
});

const computedTitle = computed(() => {
    if (!seoTags.value?.page_title) return "Tyre Seeker | Tyre Reviews | Tyre Tests & Ratings";

    if (!props.noAppName) {
        const appName = usePage().props.value.config.name;

        return `${seoTags.value.page_title} | ${appName}`;
    }

    return seoTags.value.page_title;
});
</script>

<style scoped>

</style>
